<template>
  <div
    class="editable-input"
    contenteditable="true"
    :data-placeholder="placeholder"
    ref="editableDiv"
    :class="{ invalid: isInvalid }"
    @input="onInput"
    @blur="onBlur"
  ></div>
</template>

<script>
export default {
  name: 'EditableInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isInvalid: false,
    };
  },
  mounted() {
    this.$refs.editableDiv.textContent = this.value || '';
    this.validate();
  },
  watch: {
    value(newVal) {
      if (
        this.$refs.editableDiv &&
        this.$refs.editableDiv.textContent !== newVal
      ) {
        this.$refs.editableDiv.textContent = newVal || '';
      }
      this.validate();
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.textContent);
      this.validate();
    },
    onBlur(e) {
      this.$emit('input', e.target.textContent.trim());
      this.validate();
    },
    validate() {
      if (this.required) {
        this.isInvalid = !this.$refs.editableDiv.textContent.trim();
      } else {
        this.isInvalid = false;
      }
    },
  },
};
</script>

<style scoped>
.editable-input {
  display: inline-block;
  min-width: 65px;
  border: 1px solid #ccc;
  padding: 4px 8px;
  font-size: 16px;
  font-family: inherit;
  white-space: nowrap;
  outline: none;
  border-radius: 4px;
  transition: border 0.2s, background-color 0.2s;
}
.editable-input:empty::before {
  content: attr(data-placeholder);
  color: #999;
}
.editable-input.invalid {
  outline: 1px solid red !important;
  outline-offset: -1px;
  background-color: #ffe6e6;
}
</style>
